let cartCounter = 0; // Inicializa o contador do carrinho

function addToCart() {
    cartCounter++; // Incrementa o contador do carrinho
    updateWidgetCounter(); // Atualiza o contador do widget
}

function updateWidgetCounter() {
    let totalItems = 0; // Inicializa o contador total de itens

    // Loop através dos itens no carrinho e soma as quantidades
    cartItems.forEach(item => {
        totalItems += item.quantity;
    });

    // Atualiza o contador no widget com o número total de itens
    widgetCounter.textContent = totalItems;
}

function goToCart() {
    document.getElementById('carrinho').scrollIntoView({ behavior: 'smooth' }); // Rolagem suave até a seção do carrinho
}
